import {ActivatedRouteSnapshot, CanActivate} from '@angular/router';
import {Injectable} from '@angular/core';

import {Observable, of} from 'rxjs';
import {catchError, filter, switchMap, take, tap} from 'rxjs/operators';
import {select, Store} from '@ngrx/store';

import {ApplicationState} from '../../application-state/store';
import {OrderCommentsActions, ProductOrderItemsActions} from '../store';
import {OrderCommentsSelectors, ProductOrderItemsSelectors} from '../store/selectors';

@Injectable()
export class ProductOrderItemsLoadedGuard implements CanActivate {

  constructor(private store: Store<ApplicationState>) {
  }

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {

    const orderUuid = route.params.uuid;
    this.store.dispatch(ProductOrderItemsActions.ReadProductOrderItems({orderUuid}));

    return of(true);

    /*return this.loadProductOrderItemsDone(iri).pipe(
      switchMap(() => of(true)),
      catchError(() => of(false))
    );*/
  }

  loadProductOrderItemsDone(orderUuid: string) {
    return this.store.pipe(
      select(ProductOrderItemsSelectors.isLoaded),
      tap((loaded: boolean) => {
        if (!loaded) {
          this.store.dispatch(ProductOrderItemsActions.ReadProductOrderItems({orderUuid}));
        }
      }),
      filter(loaded => loaded),
      take(1)
    );
  }
}
